import Vue from 'vue'; 

import 'element-ui/lib/theme-chalk/index.css';

import { 
    Message,
    Tooltip,
    Input,
    Select,
    Option,
    Pagination,
    Row,
    Col, 
    Progress,
    Checkbox,
    CheckboxGroup,
    DatePicker,
    TimePicker,
    Switch,
    Loading,
    Radio,
    RadioGroup,
    RadioButton,
    Table,
    TableColumn,
    Cascader,
    Carousel,
    CarouselItem,
    Popover,
    Tabs,
    TabPane,
    ColorPicker

} from 'element-ui' 
Vue.use(ColorPicker);
Vue.use(Tabs);Vue.use(TabPane);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(DatePicker);
Vue.use(Pagination);
Vue.use(Switch);
Vue.use(Loading);
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Tooltip)